import React from "react"
import { Link } from "gatsby"

import logoSVG from "../images/ee-web-logo.svg"

const Footer = () => (
  <footer className="py-5 has-background-white-ter">
    <div className="container">
      <div className="columns m-0">
        <div className="column is-one-quarter">
          <div className="image">
            <img src={logoSVG} alt="EtchingX" height="95" width="216"/>
          </div>
        </div>
        <div className="column is-one-quarter">
          <h6 className="is-size-5 is-uppercase">Etching Expressions</h6>
          <ul>
            <li><Link to="/pages/about-etchingx-designs/">About Us</Link></li>
            <li><Link to="/collections/all/">About Our Products</Link></li>
            <li><Link to="/pages/affiliates/">Affiliates</Link></li>
            <li><Link to="/pages/galleries/">Galleries</Link></li>
            <li><Link to="/pages/reviews/">Reviews</Link></li>
            <li><Link to="/blogs/etchingx/">Blog</Link></li>
          </ul>
        </div>
        <div className="column is-one-quarter">
          <h6 className="is-size-5 is-uppercase">Customer Support</h6>
          <ul>
            <li><Link to="/pages/faq/">FAQ</Link></li>
            <li><Link to="/pages/contact-us/">Contact Us</Link></li>
            <li><Link to="/pages/store-policies/">Store Policies</Link></li>
            <li><Link to="/pages/privacy-policy/">Privacy Policy</Link></li>
            <li><Link to="/pages/terms-of-use/">Terms of Use</Link></li>
            <li><Link to="/pages/accessibility/">Accessibility</Link></li>
          </ul>
        </div>
        <div className="column is-one-quarter">
          <h6 className="is-size-5 is-uppercase">Call Us</h6>
          <p>
            <strong>866-944-3824</strong>
            <br/>
            8AM - 5PM Pacific
            <br/>
            Mon - Fri
          </p>
        </div>
      </div>
      <div className="columns mx-0 my-4" style={{ borderTop: "1px solid #c8b997" }}>
        <div className="column is-full">
          © {new Date().getFullYear()}
          {` `}
          <Link to="/">EtchingX</Link>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer